<template>
  <div class="datagrid-toolbar">
    <div class="pull-left">
      <slot name="left" />
    </div>
    <div class="pull-right" v-if="showRightBtn">
      <slot name="right" />
      <h-dropdown trigger="click" placement="bottom-end" @on-visible-change="settingHandle" v-if="showSettingBtn">
        <h-button type="ghost" icon="t-b-setting">
          <h-icon :name="settingIcon"></h-icon>
        </h-button>
        <div class="dropdown-list" slot="list" :style="widthStyle">
          <div v-for="(it, idx) in showColumns" :key="idx" class="dropdown-item">
            <h-checkbox :value="it.key || it.type" :true-value="it.key || it.type" :false-value="it.key || it.type" :disabled="it.disabled" @on-change="checkHandle">
              <span class="ml">{{it.title}}</span>
            </h-checkbox>
          </div>
        </div>
      </h-dropdown>
    </div>
  </div>
</template>
<script>
import cloneDeep from 'clone-deep'
export default {
  name: 'HToolbar',
  props: {
    showRightBtn: {
      type: Boolean,
      default: true
    },
    showSettingBtn: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      required: true
    },
    dropListWidth: {
      type: String,
      default: '120px'
    }
  },
  data () {
    return {
      settingIcon: 'unfold'
    }
  },
  computed: {
    showColumns () {
      // 数据过滤
      let nvs = this.columns.filter(it => it.key || it.type)
      let target = cloneDeep(nvs)
      return target.map(it => {
        if (it.type === 'selection') {
          it.title = '选择框'
        }
        return it
      })
    },
    widthStyle () {
      return { width: `${this.dropListWidth}` }
    }
  },
  methods: {
    settingHandle (visible) {
      this.settingIcon = visible ? 'packup' : 'unfold'
    },
    checkHandle (val) {
      // 触发父组件的input事件
      this.$emit('on-change', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.datagrid-toolbar {
  .pull-right {
    display: flex;
    flex-direction: row;
    .dropdown-list {
      max-width: 120px;
      max-height: 200px;
      overflow: auto;
      .dropdown-item {
        .h-checkbox-wrapper {
          white-space: nowrap;
        }
      }
    }
    .ml {
      margin-left: 4px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
